import { useMemo, useRef, useState } from "react";
import accordionStyle from "../../sass/custom/accordion.module.scss";
import { CARD_ONLINE_PAYMENT_TYPE, paymentTypes } from "../../data/static-data";
import { useTranslation } from "react-i18next";
import { convertApiTimeToString } from "../../helpers/time/convertApiTime";

const getCurrencySymbol = (currency) => {
    switch (currency) {
        case "USD":
            return "$";
        case "EUR":
            return "€";
        case "RUB":
            return "₽";
        case "TRY":
            return "₺";
        default:
            return "err";
    }
}

const BillInfoDetails = ({ bill, isSelected }) => {
    const { t, i18n } = useTranslation();
    const accordionDetailsRef = useRef(null);
    const [accordionOpened, setAccordionOpened] = useState(false);

    const toggleAccordionDetails = () => {
        //if already opened
        if (accordionDetailsRef.current.style.maxHeight) {
            setAccordionOpened(false);
            accordionDetailsRef.current.style.maxHeight = null;
        }
        // if closed
        else {
            setAccordionOpened(true);
            accordionDetailsRef.current.style.maxHeight =
                accordionDetailsRef.current.scrollHeight + "px";
            console.log(accordionDetailsRef.current.style.maxHeight);
        }
    };

    const paymentType = useMemo(() => {
        if (bill && bill["payment-type"]) {
            return (
                paymentTypes.find(
                    (type) => type.value === bill["payment-type"]
                ) ?? null
            );
        }
    }, [bill]);

    return (
        <div>
            {/* Details */}
            <div className="flex flex-col items-center">
                {/* Details */}
                <div
                    className={`${accordionStyle.accordionDetails} w-full`}
                    ref={accordionDetailsRef}
                >
                    {bill && (
                        <>
                            <div className="w-full pt-1 pb-3 grid grid-cols-2 text-left">
                                {/* Bill creation time */}
                                <div className="flex flex-col items-start mb-2">
                                    <span className="font-normal ">
                                    {t("bills.bill_info.details.payment_time")}:{" "}
                                    </span>
                                    <span className="font-medium">
                                        {bill["paid"] ? convertApiTimeToString(bill["payment-time"]) : t("bills.bill_info.details.not_paid")}
                                    </span>
                                </div>

                                <div className="flex flex-col items-start mb-2">
                                    <span className="font-normal ">
                                    {t("bills.bill_info.details.payment_type")}:{" "}
                                    </span>
                                    <span className="font-medium">
                                        {paymentType
                                            ? paymentType.text[i18n.language]
                                            : "XZ"}
                                    </span>
                                </div>
                                {!bill.paid && (
                                    <>
                                        <div>
                                            <span className="font-medium">
                                                TL:{" "}
                                            </span>
                                            <span className="">
                                                {bill["end-price-tl"]}₺
                                            </span>
                                        </div>
                                        <div>
                                            <span className="font-medium">
                                                EUR:{" "}
                                            </span>
                                            <span className="">
                                                {bill["end-price-eur"]}€
                                            </span>
                                        </div>
                                        <div>
                                            <span className="font-medium">
                                                RUB:{" "}
                                            </span>
                                            <span className="">
                                                {bill["end-price-rub"]}₽
                                            </span>
                                        </div>
                                    </>
                                )}
                                {/* Paid online so we have payment-amount and currency */}
                                {bill.paid && bill["payment-type"] === CARD_ONLINE_PAYMENT_TYPE && (
                                    <div className="flex flex-col items-start mb-2">
                                        <span className="font-normal ">
                                            {t("bills.bill_info.details.payment_amount")}:{" "}
                                        </span>
                                        <span className="font-medium">
                                            {bill["payment-amount"]} {getCurrencySymbol(bill["payment-currency"])}
                                        </span>
                                    </div>
                                )}

                                {/* Paid offline in office so payment amount and currency is in TRY */}
                                {bill.paid && bill["payment-type"] !== CARD_ONLINE_PAYMENT_TYPE && (
                                    <div className="flex flex-col items-start mb-2">
                                        <span className="font-normal ">
                                            {t("bills.bill_info.details.payment_amount")}:{" "}
                                        </span>
                                        <span className="font-medium">
                                            {bill["end-price-tl"]} {getCurrencySymbol("TRY")}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>

                {/* Expand more button */}
                <div
                    onClick={toggleAccordionDetails}
                    className={`w-full h-full relative items-center cursor-pointer ${
                        isSelected
                            ? "bg-green-100 hover:bg-green-200"
                            : "bg-gray-100 hover:bg-gray-200"
                    }`}
                    style={{
                        height: "20px",
                        transition: "all .5s ease",
                    }}
                >
                    <img
                        className="absolute inset-0 m-auto"
                        src="/static/images/svg/expand-more.svg"
                        alt="expand more icon"
                        width={30}
                        height={30}
                        style={{
                            transform: accordionOpened
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                            transition: "all .2s ease",
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default BillInfoDetails;
